//@ts-ignore
import { Modal, ModalBody, ModalHeader, ModalFooter, Form, FormGroup, Label } from 'reactstrap'
import { IconLock, IconX } from '@tabler/icons-react'
import MultiSelectAll from '../_atoms/MultiSelectAll'
//@ts-ignore
import { Button, Textarea } from 'dsm-react-lib'
import { useForm } from 'react-hook-form'
import { ChangeEvent, useState } from 'react'
import endpointMapper from '../../_endpoints'
import { usePost } from '../../_hooks/usePost'
import { toast } from 'react-toastify'
import { useFetch } from '../../_hooks/useFetch'

interface ArcRequestModalProps {
  isOpen: boolean
  toggle: () => void
  arcRoles?: any[]
  handleOnRequest?: any
  setSelectedArcRoles?: any
  selectedArcRoles?: any[]
  isContributorReq?: boolean
}

const ArcRequestModal: React.FC<ArcRequestModalProps> = ({
  isOpen,
  toggle,
  arcRoles,
  handleOnRequest,
  setSelectedArcRoles,
  selectedArcRoles,
  isContributorReq = false
}) => {
  const {
    trigger,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()
  const [description, setDescription] = useState('')
  const [isRequesting, sendContributorReq] = usePost()
  const [isRequestingArc, setIsRequestingArc] = useState(false)
  const [, getUserDetailsData] = useFetch()
  const userInfoDataString = localStorage?.getItem('userInfoData')
  const existingUserInfoData = userInfoDataString && JSON.parse(userInfoDataString)

  const handleClose = () => {
    if (!isContributorReq && setSelectedArcRoles) {
      setSelectedArcRoles([])
    }
    toggle()
  }

  const onArcRequestRequestedHandler = () => {
    setIsRequestingArc(true)
    handleOnRequest(selectedArcRoles)
    handleClose()
  }

  const onSubmit = async () => {
    const isValid = await trigger()
    if (isValid && isContributorReq) {
      const response = await sendContributorReq({
        url: endpointMapper.bff.contributorAccess,
        data: {
          details: description
        }
      })
      const userData = await getUserDetailsData(`${endpointMapper.bff.getUserDetails}`)

      const updatedUserInfoData = {
        ...existingUserInfoData,
        userMetaData: {
          ...userData.userMetaData,
          isInvDesktopContributorArcRequestRaised:
            userData.userMetaData.isInvDesktopContributorArcRequestRaised
        }
      }

      localStorage.setItem('userInfoData', JSON.stringify(updatedUserInfoData))

      if (response.isSuccess) {
        toast.success('Your request has been sent successfully')
      } else {
        toast.error('Error occurred while raising the request')
      }
      handleClose()
    }
  }

  return (
    <>
      <Modal isOpen={isOpen} toggle={handleClose} centered>
        <div onClick={(e) => e.stopPropagation()}>
          <ModalHeader
            className="!justify-between !border-0 !flex !items-center"
            data-testid="modalCloseBtn"
            close={
              <IconX
                size={24}
                onClick={(e) => {
                  e.stopPropagation()
                  handleClose()
                }}
                className="theme-text-subheading transition-colors duration-300 ease-in-out hover:text-[var(--text-subheading)] cursor-pointer"
                data-testid="close-button"
              />
            }>
            <div className="flex items-center">
              {isContributorReq ? 'Request Contributor access' : 'Request ARC access'}
            </div>
          </ModalHeader>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <ModalBody className="px-[3.2rem] py-[0.8rem]">
              <>
                <div className="flex justify-center items-center">
                  <IconLock size={114} color="var(--color-warning)" />
                </div>
                {isContributorReq ? (
                  <FormGroup className="mt-1">
                    <Label>Please describe reasons for this access request:</Label>
                    <Textarea
                      name="description"
                      id="description"
                      rows={3}
                      maxLength={100}
                      defaultValue={description}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        setDescription(e.target.value)
                      }}
                      placeholder="So we can assess your request please describe how you wish to use this role including which applications you would like to onboard or manage."
                      ref={register({ required: true })}
                      invalid={'description' in errors}
                      helperText={'description' in errors ? 'Description is mandatory' : ''}
                      data-testid="contributorAccessDescription"
                    />
                  </FormGroup>
                ) : (
                  <FormGroup>
                    <Label>Select ARC role:</Label>
                    <MultiSelectAll
                      options={
                        arcRoles &&
                        arcRoles?.map((e: any) => ({
                          label: e,
                          value: e
                        }))
                      }
                      placeholder="ARC role"
                      handleFilterChange={(e: any) => setSelectedArcRoles(e)}
                      multi={true}
                      closeMenuOnSelect={true}
                      selectedValues={selectedArcRoles}
                      isClearable={false}
                    />
                  </FormGroup>
                )}
              </>
            </ModalBody>
            <ModalFooter>
              <Button
                label={isRequesting || isRequestingArc ? 'Requesting...' : 'Request access'}
                color="warning"
                type="submit"
                onClick={(e: React.MouseEvent) => {
                  e.stopPropagation()
                  if (isContributorReq) {
                    onSubmit()
                  } else {
                    onArcRequestRequestedHandler()
                  }
                }}
                disabled={
                  (!isContributorReq && !selectedArcRoles?.length) || isRequesting
                }></Button>
            </ModalFooter>
          </Form>
        </div>
      </Modal>
    </>
  )
}

export default ArcRequestModal
